// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I8pS","col":"styles_col__19OKR"};